import { useMemo } from 'react';

//* HOC's
import withDataContext from 'context/consumerHOC/DataConsumer';

//* Components
import Page from 'components/common/Page';
import Info from 'components/common/Info';
import Paths from 'components/common/Paths';
import Content from 'components/common/Content';
import Feedback from 'components/common/Feedback';
import Container from 'components/common/Container';
import BackButton from 'components/common/BackButton';
import RelatedBlogPosts from 'components/common/RelatedBlogPosts';

//* Style
import ArticleIndividualStyle from 'styles/pages/ArticleIndividualStyle';

const NewsRoom = ({ singleNewsRoom, pageParams, selectedLang, prevRoute }) => {
	//! Page Data
	const pageData = useMemo(() => singleNewsRoom?.[pageParams.selectedSlug]?.[selectedLang], [singleNewsRoom, pageParams, selectedLang]);

	return (
		<Page
			meta={pageData?.newsRoom?.meta}
			transparentHeader={pageParams.transparentHeader && !pageData}
			nextSeoProps={{
				noindex: selectedLang != 'en',
			}}
			hrefLang={false}
		>
			{pageData && (
				<ArticleIndividualStyle>
					<div className='page-top'>
						<Paths
							paths={['News Room', pageData.newsRoom.title]}
							pathColor={'primaryColor1'}
						/>

						<BackButton
							prevRoute={prevRoute}
							backRoute={'/'}
							text={'back'}
							isArticle={prevRoute?.asPath == '/articles/' || !prevRoute}
						/>
					</div>

					<Container
						section
						className='main-content-wrap'
					>
						<Info
							isSticky={true}
							data={pageData.newsRoom}
						/>

						<Content
							image={pageData.newsRoom.banner_image}
							text={pageData.newsRoom.description}
							publishedOn={pageData.newsRoom.published_on}
							additional={pageData.newsRoom.additional}
						/>
					</Container>

					<Container section>
						<Feedback
							type={pageData.newsRoom.feedbackType}
							typeId={pageData.newsRoom.id}
						/>
					</Container>

					{pageData?.relatedNewsRooms?.length > 0 && (
						<RelatedBlogPosts
							relatedTitle={'moreOfPressReleases'}
							articles={pageData.relatedNewsRooms}
						/>
					)}
				</ArticleIndividualStyle>
			)}
		</Page>
	);
};

export default withDataContext(NewsRoom, ['singleNewsRoom', 'prevRoute']);
